import { ListItem } from './lists.model';

// verse
export class ARBleAzoteFrequency extends ListItem {}

export class ARVerseApportMoAutomne extends ListItem {}

export class ARVerseApportsMinerauxFractionnement extends ListItem {}

// TODO PPF supprt
export class ARBleAzoteProductType extends ListItem {}

export class ARBleEtatVegetatifSh extends ListItem {}

export class ARBleAzotePeriod extends ListItem {}

export class ARBlePastResiduType extends ListItem {}

export class ARBlePrairieAge extends ListItem {}

export class ARBlePrairieDestructionPeriod extends ListItem {}

export class ARBlePrairiePostDestructionRank extends ListItem {}

export class ARBlePrairieExploitationMode extends ListItem {}

export class ARBlePrairieType extends ListItem {}

export class ARBleCIType extends ListItem {}

export class ARBleCIDevelopment extends ListItem {}

export class ARBleCIDestructionPeriod extends ListItem {}

export class ARBleResultType extends ListItem {
  visible: boolean;
}

export class ARBleOrderType extends ListItem {}
